import type { AppServices } from 'src/common/services';

export interface LoaderArgs {
  params: Record<string, string | undefined>;
  location: { pathname: string; search: string };
  services: AppServices;
}

const loaderTag = Symbol('routeLoader');

export interface RouteLoader<Data = unknown> {
  readonly [loaderTag]: true;
  load: (args: LoaderArgs) => Promise<Data> | Data;
}

/**
 * Defines what a route needs before it renders, as a function of its params, location and the
 * services. It depends on neither Redux nor the router: `connectAsync` runs loaders today, and a
 * framework's own data loading can run the same functions later.
 */
export function defineLoader<Data>(load: RouteLoader<Data>['load']): RouteLoader<Data> {
  return { [loaderTag]: true, load };
}

export function isRouteLoader(value: unknown): value is RouteLoader {
  return typeof value === 'object' && value !== null && loaderTag in value;
}
